export default {
  pt: {
    pageTitle: "Informações da bicicleta",
    mainTitle: "Qual o número de série?",
    description: "Localize o número de série da sua bicicleta. Em caso de dúvida, fale com seu lojista.",
    serialNumberLabel: "Número de série",
    patternLabel: "Formato esperado",
    hint: "Você encontra o número de série no quadro, geralmente sob o movimento central (entre os pedais) ou próximo à roda traseira, tubo inferior ou caixa de direção.",
    dialogTitle: "Atenção",
    dialogMessage: "Você será redirecionado para a jornada de seguros",
    understoodButton: "Entendi",
    warningFoundTag: "Foi encontrado uma tag com este número de série. É necessário fazer o scan da tag para continuar."
  },

  en: {
    pageTitle: "Bicycle information",
    mainTitle: "What is the serial number?",
    description: "Locate your bicycle's serial number. If in doubt, talk to your dealer.",
    serialNumberLabel: "Serial number",
    patternLabel: "Expected format",
    hint: "You can find the serial number on the frame, usually under the bottom bracket (between the pedals) or near the rear wheel, downtube, or head tube.",
    dialogTitle: "Attention",
    dialogMessage: "You will be redirected to the insurance journey",
    understoodButton: "I understand",
    warningFoundTag: "A tag with this serial number was found. You must scan the tag to continue."
  },
};
